import { NOTIFICATION_TYPE_ENUM, TOKEN_ERROR_TYPE_ENUM } from "interfaces";

import { NotificationProps } from "providers";

import { parseErrorMessage } from "utils";

export interface RequestWithNotifyParams {
  fetchFn: () => Promise<any>;
  openNotification: (props: NotificationProps) => void;
  delay?: number;
  successMsg?: string;
  errorMsg?: string;
  showErrorNotification?: boolean;
}

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const requestWithNotify = async ({
  fetchFn,
  openNotification,
  delay = 0,
  successMsg,
  errorMsg,
  showErrorNotification = true,
}: RequestWithNotifyParams) => {
  if (delay) {
    await sleep(delay);
  }

  try {
    const response = await fetchFn();

    if (successMsg) {
      openNotification({
        message: successMsg,
        type: NOTIFICATION_TYPE_ENUM.SUCCESS,
      });
    }

    return {
      response,
      result: true,
    };
  } catch (error: any) {
    if (showErrorNotification) {
      openNotification({
        message: errorMsg ? errorMsg : parseErrorMessage(error),
        type: NOTIFICATION_TYPE_ENUM.ERROR,
      });
    }

    return {
      result: false,
    };
  }
};
